import { Star } from 'lucide-react'
import { fbt } from 'fbtee'
import { cn } from '../lib/utils'
import { Button } from './ui/button'

export function FavoriteStar({
  active,
  onToggle,
  size = 'icon',
  className,
}: {
  active: boolean
  onToggle: () => void
  size?: 'icon' | 'icon-sm'
  className?: string
}) {
  const label = active
    ? fbt('Remove from favorites', 'Accessible label for the button that unfavorites a friend')
    : fbt('Add to favorites', 'Accessible label for the button that favorites a friend')
  return (
    <Button
      size={size}
      variant="ghost"
      aria-label={label}
      aria-pressed={active}
      title={label}
      onClick={e => {
        e.stopPropagation()
        onToggle()
      }}
      className={cn('cursor-pointer', className)}
    >
      {/* Favorites are amber to read as distinct from the rose "interested"
          heart and the blue primary action — the same off-palette engagement
          signal rationale as the heart. */}
      <Star
        className={cn(
          size === 'icon-sm' ? 'size-3.5' : 'size-4',
          active ? 'fill-amber-400 text-amber-400' : 'text-muted-foreground',
        )}
      />
    </Button>
  )
}
